import gql from "graphql-tag";

/**
 * GraphQL Mutations for updating the user
 */

 const PortUserMutation = gql`
mutation($email: String! , $user_name: String!, $id: String!, $full_name: String!) {
    UpdatePortUser(email: $email, user_name: $user_name, id: $id, full_name: $full_name) {
      full_name
    }
  }
 `


 const NimasaUserMutation = gql`
mutation($email: String! , $user_name: String!, $id: String!, $full_name: String!) {
    UpdateNimasaUser(email: $email, user_name: $user_name, id: $id, full_name: $full_name) {
      full_name
    }
  }
 `

const NimasaAdminUserMutation = gql`
  mutation($email: String! , $user_name: String!, $id: String!,  $full_name: String!) {
    UpdateNimasaAdminUser(email: $email, user_name: $user_name, id: $id, full_name: $full_name) {
      full_name
    }
  }
`;

 export default {
     NimasaAdminUserMutation, NimasaUserMutation,
     PortUserMutation
 }
